import OrderItem from "./order-item";

export default class Order {
  id: number;
  name: string;
  orderItems: OrderItem[] = [];
}



// WEBPACK FOOTER //
// ./src/models/orders/order.ts